import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Container, CardMedia, Box, Typography, CircularProgress, Button } from '@mui/material';
import { WhatsApp, Facebook, Share, ArrowBack } from '@mui/icons-material';
import axios from 'axios';
import { primaryColor } from '../theme';
import '../App.css';
import html2pdf from 'html2pdf.js';

const ContentDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [content, setContent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [userId, setUserId] = useState('');

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem('user'));
    if (user) {
      setUserId(user.id);
    }
  }, []);

  useEffect(() => {
    const fetchContent = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/content/${id}`);
        setContent(response.data);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching content:', error);
        setError('Content not found');
        setLoading(false);
      }
    };

    fetchContent();
  }, [id]);

  const handleDownload = async (id) => {
    try {
      await axios.post(`${process.env.REACT_APP_API_BASE_URL}/content/${id}/download`, { userId });
    } catch (error) {
      console.error('Error tracking view:', error);
    }
  };

  if (loading) {
    return <CircularProgress />;
  }

  if (error) {
    return <Typography variant="h6" color="error">{error}</Typography>;
  }

  const handleSaveOffline = (id) => {
    handleDownload(id)
    // const element = document.getElementById('content-detail');
    // const opt = {
    //   margin:       1,
    //   filename:     `${content.topic}.pdf`,
    //   image:        { type: 'jpeg', quality: 0.98 },
    //   html2canvas:  { scale: 2 },
    //   jsPDF:        { unit: 'in', format: 'letter', orientation: 'portrait' }
    // };
    // html2pdf().from(element).set(opt).save();
    window.print();
  };

  const getPresentationEmbedUrl = (url) => {
    if (url.endsWith('.pptx')) {
      return `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(url)}`;
    }
    return url;
  };

  return (
    <Container maxWidth="lg" sx={{ mt: 4 }}>
      <Button startIcon={<ArrowBack />} onClick={() => navigate(-1)} sx={{ mb: 2 }} >
        Go Back
      </Button>
      <Box>
      <Typography variant="h4" gutterBottom style={{ color: primaryColor }}>
        {content.topic}
      </Typography>
      {/* <Typography variant="subtitle1" gutterBottom>
        {content.targetUser} - {content.valueChain}
      </Typography> */}
      {content.video && (
        <Box mt={2}>
          <CardMedia
            component="video"
            controls
            height="200"
            src={content.video}
            title={content.topic}
          />
        </Box>
      )}
      {content.audio && (
        <Box mt={2}>
          <audio controls>
            <source src={content.audio} type="audio/mpeg" />
            Your browser does not support the audio element.
          </audio>
        </Box>
      )}
      {content.presentation && (
        <Box mt={2}>
          <iframe
            src={getPresentationEmbedUrl(content.presentation)}
            width="100%"
            height="400"
            title={content.topic}
            frameBorder="0"
            allowFullScreen
          />
        </Box>
      )}
      <Box id="content-detail">
        <Typography variant="body1" dangerouslySetInnerHTML={{ __html: content.content }} />
      </Box>
      {content.platform === 'Written' && (
        <Box mt={2} mb={4} display="flex" gap={2}>
          <Button
            variant="contained"
            color="primary"
            onClick={() => handleSaveOffline(content.id)}
          >
            Downoad as PDF
          </Button>
        </Box>
      )}
    </Box>

    </Container>
  );
};

export default ContentDetail;